import { Axios, MutationConfig } from '@helpers';
import { useMutation, useQueryClient } from 'react-query';
import { getSocialMediaLinksQueryOptions } from './get-social-links';

export const enforceSocialMedia = ({
  data,
  modelId,
}: {
  data: { ids: string[] };
  modelId: string;
}) => {
  return Axios.patch(`/admin/models/${modelId}/social-media-links/enforce`, data);
};

type UseEnforceSocialMedia = {
  mutationConfig?: MutationConfig<typeof enforceSocialMedia>;
};

export const useEnforceSocialMedia = ({ mutationConfig }: UseEnforceSocialMedia = {}) => {
  const { onSuccess, ...restConfig } = mutationConfig || {};
  const queryClient = useQueryClient();

  return useMutation({
    onSuccess: (...args) => {
      queryClient.invalidateQueries({
        queryKey: getSocialMediaLinksQueryOptions().queryKey,
      });
      onSuccess?.(...args);
    },
    ...restConfig,
    mutationFn: enforceSocialMedia,
  });
};
